import React, {useEffect} from 'react';
import './DatasetButtonComponent.scss';
import {Tooltip} from "react-tooltip";
import DatasetTooltipText from "../../basic/dataset-tooltip-text/DatasetTooltipText";
import {DatasetDataInfo} from "../../../models/dataset-models";

import {InstantDoubleValue} from "../../../api/model/dataset/InstantDoubleValue";

type DatasetButtonProps = {
    id: string;
    value: string | undefined;
    selected: boolean;
    className?: string;
    dataset: DatasetDataInfo;
    data: InstantDoubleValue | null | undefined,
    time: Date,
    style?: React.CSSProperties,

    setIdentifiers(id: string, ctrlPressed: boolean, doubleClick: boolean): void;
}

const DatasetButtonComponent = (props: DatasetButtonProps) => {
    const pointerOnElement = React.useState(false);

    useEffect(() => {
        document.addEventListener("keydown", keyPressedToCopy);
        return () => {
            document.removeEventListener("keydown", keyPressedToCopy);
        }
    }, [])

    const onPointerElementHandler = (e: any) => {
        if (e.type === "pointerenter" && !pointerOnElement[0]) {
            pointerOnElement[0] = true;
        } else if (e.type === "pointerleave" && pointerOnElement[0]) {
            pointerOnElement[0] = false;
        }
    }

    const keyPressedToCopy = (e: any) => {
        if (pointerOnElement[0]) {
            if (e.code === "KeyC" && e.ctrlKey) {
                textToClipboard(props.dataset.title);
                PF('globalGrowl').renderMessage(
                    {
                        "summary": "Copied Dataset tag",
                        "detail": props.dataset.title,
                        "severity": "info"
                    }
                );
            }
        }

    }

    const onButtonClick = (e: any) => {
        if (e.ctrlKey) {
            props.setIdentifiers(props.dataset.identifier as string, true, false);
        }
    }

    const onDbClick = (e: any) => {
        if (e.ctrlKey) {
            props.setIdentifiers(props.dataset.identifier as string, true, true);
        } else {
            props.setIdentifiers(props.dataset.identifier as string, false, true);
        }
    }

    return (<>
        <Tooltip anchorSelect={`#${props.id}`} style={{zIndex: 99999}}>
            <DatasetTooltipText data={props.data} time={props.time} dataset={props.dataset} />
        </Tooltip>
        <div className={props.selected ? "button-wrapper button-clickable selected-label" : "button-wrapper button-clickable"}
             id={props.id ? props.id : ""}
             onClick={(e) => onButtonClick(e)}
             onDoubleClick={(e) => onDbClick(e)}
             onPointerEnter={(e) => onPointerElementHandler(e)}
             onPointerLeave={(e) => onPointerElementHandler(e)}
             style={props.style}
        >
            {typeof props.value === "string" ?
                <>{props.value + " "}{props.dataset.unit ? props.dataset.unit : ""}</>
                :
                <>N/A</>
            }
        </div>
    </>);
}

export default DatasetButtonComponent;